module.exports = __webpack_public_path__ + "img/hair1.91453f46.svg";